<div class="tw-flex tw-justify-between tw-mr-[5px]">
  <h2
    [id]="titleId"
    class="tw-pt-5 tw-m-0 tw-pl-6 tw-text-base tw-font-semibold"
    [ngClass]="{ 'tw-flex-1 tw-text-center': centered }"
  >
    <ng-content></ng-content>
  </h2>
  <button
    type="button"
    id="closeButton"
    mat-icon-button
    class="close"
    [mat-dialog-close]="false"
    data-close="modal"
    aria-label="Click to close this modal"
  >
    <mat-icon svgIcon="close" />
  </button>
</div>
